import RequestPage from "./RequestPage";

const ExternalPackenham = () => {
 return (
        <RequestPage title="External Retreat Packenham"
            fetchUrl="/get-external-retreat-packenham-requests"
            editEndpoint="edit-external-retreat-packenham-request"
            deleteEndpoint="external-retreat-packenham-request"
            statusEndpoint="external-retreat-packenham-request" />
    );
}

export default ExternalPackenham;